<!--
  CollectorTmaScreen — «افتح يومك في كروم» (collector-app P2-B, locked answer
  L-A). Inside the Telegram Mini App the collector's day does not live: the app
  runs no service worker there and the Telegram cleanup wipes every cache, so
  the day would not survive no signal. Both collector pages render ONLY this
  screen inside Telegram, with the existing launch handoff
  (utils/launchTarget.js `launchInBrowser`: a single-use token, then Chrome on
  Android through the intent, the browser elsewhere) — nothing else, and no
  storage or network of the collector layer runs.

  In flow, `height: 100%` — no fixed position or viewport units: Telegram's
  visible area is not the WebView's (playbook row 28).
-->
<template>
  <div class="c-tma">
    <h1 class="c-tma__title">
      {{ t('collector.tma.title') }}
    </h1>
    <button
      type="button"
      class="c-reset c-tma__btn"
      :disabled="busy"
      @click="open"
    >
      {{ busy ? t('collector.tma.preparing') : t(android ? 'collector.tma.chrome' : 'collector.tma.browser') }}
    </button>
  </div>
</template>

<script setup>
import { f7 } from 'framework7-vue';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { adapter } from '@/platform/index.js';
import { isAndroid, launchInBrowser } from '@/utils/launchTarget.js';

const { t } = useI18n();
const android = isAndroid();
const busy = ref(false);

async function open() {
  if (busy.value) return;
  busy.value = true;
  adapter.hapticImpact?.('light');
  try {
    await launchInBrowser({ chrome: android });
  } catch {
    try {
      f7?.toast?.create({ text: t('collector.tma.failed'), position: 'center', closeTimeout: 2500 }).open();
    } catch {
      /* no F7 app yet */
    }
  } finally {
    busy.value = false;
  }
}
</script>

<style scoped>
.c-tma {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  height: 100%;
  min-height: 320px;
  padding: 32px 24px;
  box-sizing: border-box;
  text-align: center;
}

.c-tma__title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: var(--c-ink);
}

.c-tma__btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 320px;
  height: 52px;
  border-radius: var(--c-radius-button);
  background: var(--c-indigo);
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
}

.c-tma__btn:disabled {
  opacity: 0.7;
}
</style>
